import { module } from "angular";
import { SliderComponent } from "./SliderComponent";

module("mmGui").component("mmSlider", new SliderComponent());
